const taxiStatusLabels = {
  requested: 'Buscando taxi',
  pending: 'Buscando taxi',
  offer_received: 'Ofertas recibidas',
  accepted: 'Conductor asignado',
  driver_on_way: 'Conductor en camino',
  arriving: 'El taxi va en camino',
  arrived: 'Conductor llego',
  in_progress: 'Viaje en curso',
  completed: 'Viaje completado',
  cancelled: 'Cancelado',
  expired_no_driver: 'Caducado sin conductor',
  auto_cancel_driver_delay: 'Cancelado por demora del conductor'
};

const deliveryStatusLabels = {
  pending: 'Buscando delivery',
  accepted: 'Delivery aceptado',
  picked_up: 'Pedido recogido',
  in_transit: 'En camino',
  on_the_way: 'En camino',
  delivered: 'Entregado',
  cancelled: 'Cancelado'
};

const foodStatusLabels = {
  pending_restaurant: 'Esperando confirmacion del restaurante',
  accepted_by_restaurant: 'Restaurante acepto el pedido',
  preparing: 'Preparando tu comida',
  ready_for_pickup: 'Listo para recoger',
  waiting_delivery: 'Buscando delivery',
  delivery_assigned: 'Delivery asignado',
  picked_up: 'Comida recogida',
  on_the_way: 'Tu pedido va en camino',
  delivered: 'Pedido entregado',
  cancelled: 'Cancelado',
  rejected_by_restaurant: 'Restaurante rechazo el pedido'
};

export function getStatusLabel(status, type = 'delivery') {
  const maps = {
    taxi: taxiStatusLabels,
    ride: taxiStatusLabels,
    delivery: deliveryStatusLabels,
    food: foodStatusLabels,
    comida: foodStatusLabels
  };
  return maps[type]?.[status] || status || 'Pendiente';
}

export { taxiStatusLabels, deliveryStatusLabels, foodStatusLabels };
